import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=55088d72&scoped=true&"
import script from "./AppSetting.vue?vue&type=script&lang=ts&"
export * from "./AppSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=55088d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55088d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
